import React, { PureComponent } from 'react';
import cn from 'classnames';
import { array, arrayOf, string, node } from 'prop-types';
import uuidv4 from 'uuid/v4';
import { COLOR_SCALE } from '../../constants';
import './index.css';

/**
 *
 *
 * @export
 * @class ChartLegend
 * @extends {PureComponent}
 */
export default class ChartLegend extends PureComponent {
  static displayName = 'ChartLegend';

  static propTypes = {
    data: array,
    colorScale: arrayOf(string),
    pattern: node,
    theme: array,
  };

  static defaultProps = {
    data: ['N/A'],
    colorScale: COLOR_SCALE,
    pattern: [],
  };

  render() {
    const { theme } = this.props;
    const legendCSS = cn(
      'chartlegend',
      theme ? theme.map(css => `chartlegend--${css}`).join(' ') : ''
    );
    return <ul className={legendCSS}>{this.renderCropLegend()}</ul>;
  }

  renderCropLegend = () => {
    const { data, colorScale } = this.props;

    return data.map((crop, i) => {
      const { pattern } = this.props;
      const Pattern = pattern[i];

      let component = (
        <li
          data-testid="chartLegend"
          key={uuidv4()}
          className="chartlegend__item"
        >
          <i style={{ backgroundColor: `${colorScale[i]}` }} />
          {crop}
        </li>
      );

      if (Pattern) {
        component = (
          <li
            data-testid="chartLegendPattern"
            key={uuidv4()}
            className="chartlegend__item"
          >
            {Pattern ? (
              <i>{Pattern}</i>
            ) : (
              <i style={{ backgroundColor: `${colorScale[i]}` }} />
            )}
            {crop}
          </li>
        );
      }

      return component;
    });
  };
}



// WEBPACK FOOTER //
// ./src/common/components/ChartLegend/index.js